export const THEME_ICON_MAP = {
  default: 'brightness_6',
  light: 'light_mode',
  dark: 'dark_mode',
} as const;
